import { ActivatedRouteSnapshot, DetachedRouteHandle, PreloadingStrategy, Route, RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { MessagePageComponent } from '@app/message-page/message-page.component';
import { TokenComponent } from '@app/token/token.component';
import { AuthGuard } from '@app/_guards';
import { UserType } from '@app/_helpers';
import { Observable, of } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomPreloadStrategy implements PreloadingStrategy
{
    preload(route: Route, fn: () => Observable<any>): Observable<any>
    {
        return route.data && route.data.preload ? fn() : of(null);
    }
}

const appRoutes: Routes = [
    { path: 'login', loadChildren: () => import('app/login/login.module').then(m => m.LoginModule) /** matcher: loginUrlMatcher, */ },
    {
        path: 'learnmaterial/:id',
        loadChildren: () => import('app/learnmaterial/learnmaterial.module').then(m => m.LearnmaterialModule),
        canActivate: [AuthGuard],
        data: { type: [UserType.Site, UserType.STE, UserType.Exam, UserType.Preview], preload: true }
    },
    { path: 'insight/:id', loadChildren: () => import('app/portfolio/portfolio.module').then(m => m.PortfolioModule) },
    {
        path: 'twostepauthentication/:userid/:date/:token',
        loadChildren: () => import('app/twostepauthentication/twostepauthentication.module').then(m => m.TwoStepAuthenticationModule)
    },
    { path: 'supervisor', loadChildren: () => import('app/supervisor/supervisor.module').then(m => m.SupervisorModule) },
    { path: 'token/:id', component: TokenComponent },
    {
        path: 'register/local/:learnmaterialid/:usergroupid',
        loadChildren: () => import('app/register/register.module').then(m => m.RegisterModule)
    },
    { path: 'progress/:learnperiodid', loadChildren: () => import('app/progress/progress.module').then(m => m.ProgressModule) },
    { path: 'training/:trainingid', loadChildren: () => import('app/public-training/public-training.module').then(m => m.PublicTrainingModule) },
    {
        path: 'waitingroom',
        loadChildren: () => import('app/waitingroom/waitingroom.module').then(m => m.WaitingroomModule),
        canActivate: [AuthGuard],
        data: { type: [UserType.Waiting] }
    },
    {
        path: '',
        loadChildren: () => import('app/site/site.module').then(m => m.SiteModule),
        canActivate: [AuthGuard],
        data: { type: [UserType.Site, UserType.STE] }
    },
    { path: '**', component: MessagePageComponent }

    //// otherwise redirect to root
    // { path: '**', redirectTo: '' }
];

export const routing = RouterModule.forRoot(appRoutes, {
    preloadingStrategy: CustomPreloadStrategy,
    onSameUrlNavigation: 'reload'
});

@Injectable()
export class CustomRouteReuseStrategy implements RouteReuseStrategy
{
    shouldDetach(route: ActivatedRouteSnapshot): boolean
    {
        return false;
    }
    store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void { }
    shouldAttach(route: ActivatedRouteSnapshot): boolean
    {
        return false;
    }
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null
    {
        return null;
    }
    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean
    {
        if (future.routeConfig && future.routeConfig.data && future.routeConfig.data.doNotReuse)
        {
            delete future.routeConfig.data.doNotReuse;
            return false;
        }

        return future.routeConfig === curr.routeConfig;
    }
}
